
import axios from 'axios'
import sendformData from '../utils/form-data'
import mapResponse from '../utils/map-response'
import EncryptDecrypt from '../utils/encrypt-decrypt'

export default class Services {

  private readonly baseUrl = `${process.env.VUE_APP_BEEREADERS_API_URL}/`;
  private readonly contentBaseUrl = `${process.env.VUE_APP_BEEREADERS_CONTENT_URL}/`;
  private readonly cacheBaseUrl = `${process.env.VUE_APP_BEEREADERS_CONTENT_URL}/redis/beereaders/`;
  private module: string | undefined = '';

  constructor (module?: string) {
    this.module = module
  }

  public get (url: string, params?: object, useCache = false, isEncrypted = false) {
    const response = mapResponse(axios.get(this.getUrl(url, false, useCache), params)).then((res: any) => {
        return isEncrypted ? { content : EncryptDecrypt.decryptData(res.content), status: res.status} : res
    }).catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.get(this.getUrl(url, false, useCache), params))
        }
        if (err.code === 'redo-without-cache'){
          return mapResponse(axios.get(this.getUrl(url, false, false), params))
        }
        return null
      })
    return response
  }

  public post (url: string, data?: object, isEncrypted = false) {
    const response = mapResponse(axios.post(
            this.getUrl(url), isEncrypted ? { dataEncrypted: EncryptDecrypt.encryptData(data) } : data
        )).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.post(this.getUrl(url), data))
        }
        return null
      })
    return response
  }

  public put (url: string, data?: object) {
    const response = mapResponse(axios.put(this.getUrl(url), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.put(this.getUrl(url), data))
        }
      })
    return response
  }

  public delete (url: string, data?: object) {
    const response = mapResponse(axios.delete(this.getUrl(url), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.put(this.getUrl(url), data))
        }
      })
    return response
  }

  public form (url: string, data?: object, transf?: object) {
    const response = sendformData(this.getUrl(url), data, transf).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return sendformData(this.getUrl(url), data, transf)
        }
      })
    return response
  }

  public bGet (url: string, params?: object) {
    const response = mapResponse(axios.get(this.getUrl(url, true), params)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.get(this.getUrl(url, true), params))
        }
      })
    return response
  }

  public bPost (url: string, data?: object) {
    const response = mapResponse(axios.post(this.getUrl(url, true), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.post(this.getUrl(url, true), data))
        }
      })
    return response
  }

  public bPut (url: string, data?: object) {
    const response = mapResponse(axios.put(this.getUrl(url, true), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.put(this.getUrl(url, true), data))
        }
      })
    return response
  }

  public bForm (url: string, data?: object, transf?: object) {
    const response = sendformData(this.getUrl(url, true), data, transf).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return sendformData(this.getUrl(url, true), data, transf)
        }
      })
    return response
  }

  public contentGet (url: string, params?: object, useCache = false) {
    const response = mapResponse(axios.get(this.getContentUrl(url, false, useCache), params)).then((res: any) => {
      return res
  }).catch((err: any) => {
      if (err.code === 'auth/updated-info') {
        return mapResponse(axios.get(this.getUrl(url, false, useCache), params))
      }
      if (err.code === 'redo-without-cache'){
        return mapResponse(axios.get(this.getContentUrl(url, false, false), params))
      }
      return null
    })
  return response
  }

  public contentPost (url: string, data?: object) {
    const localStore = JSON.parse(localStorage.getItem('student-beereaders-app') || '{}');

    const response = mapResponse(axios.post(
            this.getContentUrl(url,false, false), data, {
              headers: {
                'authorization': `Bearer ${localStore.token}`,
                'x-client-id': `${process.env.VUE_APP_CONTENT_MANAGER_CLIENT_ID}`
              }})
            ).then((res: any) => {
              return res
            })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.post(this.getUrl(url), data))
        }
        return null
      })
    return response
  }

  private getContentUrl (url: string, onlyBase = false, cacheServer?: boolean) {
    if (cacheServer) {
      return `${this.cacheBaseUrl}${onlyBase ? url : this.checkModule(url)}`
    }
    return `${this.contentBaseUrl}${onlyBase ? url : this.checkModule(url)}`
  }

  private getUrl (url: string, onlyBase = false, cacheServer?: boolean) {
    if (cacheServer) {
      return `${this.cacheBaseUrl}${onlyBase ? url : this.checkModule(url)}`
    }
    return `${this.baseUrl}${onlyBase ? url : this.checkModule(url)}`
  }

  private checkModule (url: string) {
    return (this.module ? (url === '' ? `${this.module}` : `${this.module}/`) : '') + url
  }
}
